import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressOverview = ({
  percentage,
  completedCount,
  totalCount,
  motivationalMessage,
  estimatedTime
}) => {
  const circumference = 2 * Math.PI * 70;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  return (
    <div className="bg-gradient-to-br from-primary/10 via-secondary/10 to-accent/10 border border-border rounded-lg p-6 md:p-8 mb-8">
      <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8">
        {/* Circular Progress */}
        <div className="relative flex-shrink-0">
          <svg className="transform -rotate-90" width="160" height="160">
            {/* Background circle */}
            <circle
              cx="80"
              cy="80"
              r="70"
              stroke="var(--color-muted)"
              strokeWidth="8"
              fill="none"
              opacity="0.2"
            />
            {/* Progress circle */}
            <circle
              cx="80"
              cy="80"
              r="70"
              stroke="var(--color-primary)"
              strokeWidth="8"
              fill="none"
              strokeDasharray={circumference}
              strokeDashoffset={strokeDashoffset}
              strokeLinecap="round"
              className="transition-all duration-500"
            />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span className="text-4xl font-bold text-foreground">{percentage}%</span>
            <span className="text-sm text-muted-foreground">Complete</span>
          </div>
        </div>

        {/* Progress Details */}
        <div className="flex-1 text-center md:text-left">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-2">
            {motivationalMessage}
          </h2>
          <p className="text-muted-foreground mb-4">
            You've completed {completedCount} out of {totalCount} setup steps.
          </p>
          
          {/* Stats */}
          <div className="flex flex-wrap gap-4 justify-center md:justify-start">
            <div className="flex items-center gap-2 px-4 py-2 bg-card/50 rounded-lg">
              <Icon name="CheckCircle2" size={20} className="text-success" />
              <div>
                <div className="text-sm font-semibold text-foreground">{completedCount} Completed</div>
                <div className="text-xs text-muted-foreground">Setup steps</div>
              </div>
            </div>
            
            <div className="flex items-center gap-2 px-4 py-2 bg-card/50 rounded-lg">
              <Icon name="Clock" size={20} className="text-primary" />
              <div>
                <div className="text-sm font-semibold text-foreground">{estimatedTime}</div>
                <div className="text-xs text-muted-foreground">To complete</div>
              </div>
            </div>
            
            {percentage === 100 && (
              <div className="flex items-center gap-2 px-4 py-2 bg-success/20 rounded-lg">
                <Icon name="Trophy" size={20} className="text-success" />
                <div>
                  <div className="text-sm font-semibold text-success">All Done!</div>
                  <div className="text-xs text-success/80">Profile complete</div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressOverview;